import { useState } from 'react'
import {
  USER_MANAGEMENT,
  userSteps,
} from '../../components/usermanagement/userManagementConstants'
//import { useSelector } from 'react-redux'

const useUserManagement = () => {
  const [selectedTab, setSelectedTab] = useState<string>(
    USER_MANAGEMENT.USER.eventKey,
  )
  const [activeStep, setActiveStep] = useState(0)
  //const userRolesData = useSelector((state: any) => state.userRole.userInfo)

  const backButtonHandler = () => {
    setActiveStep(activeStep - 1)
  }

  const continueButtonHandler = () => {
    activeStep !== userSteps.length - 1 && setActiveStep(activeStep + 1)
  }
  const handleTabSelection = (key: string) => {
    setSelectedTab(key)
  }
  return {
    handleTabSelection,
    selectedTab,
    backButtonHandler,
    continueButtonHandler,
    activeStep,
    //userRolesData,
  }
}
export default useUserManagement
